
namespace RioERP.Orders {
    export class EaseBuzzSettingsColumns {
        static columnsKey = 'Orders.EaseBuzzSettings';
    }
}